/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from "react";
import cx from "classnames";
import { Outlet, useLocation } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/UI/Footer/Footer.js";

import SidebarPro from "components/UI/SidebarPro";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";

import logoUVerify from "assets/img/uVerifyMarcaNegativa.png";
import logoUVerifyTexto from "assets/img/uVerify_S_TextoNegativo.png";

import logoStratesysSVG from "assets/img/stratesys.svg";
import logoStratesysMiniSVG from "assets/img/str.svg";
import HeaderUverify from "components/UI/HeaderUverify";
import { useSideBar } from "hooks/useSidebar";

var ps;

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const { ...rest } = props;

  const routes = props.routes;

  const { isNewHeaderUVerify } = useSideBar();

  const [logo] = React.useState(logoUVerify);

  const [logoText] = React.useState(logoUVerifyTexto);

  const [logoStratesys] = React.useState(logoStratesysSVG);

  const [logoStratesysMini] = React.useState(logoStratesysMiniSVG);

  const classes = useStyles();

  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });

  // ref for main panel div
  const mainPanel = React.createRef();
  const { pathname } = useLocation();

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  }, []);

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    if (navigator.platform.indexOf("Win") > -1) {
      let options = {
        suppressScrollX: true,
        suppressScrollY: false,
      };
      ps.update(mainPanel.current, options);
    }
  }, [pathname]);

  return (
    <div
      className={classes.wrapper}
      style={{ height: isNewHeaderUVerify && "93vh" }}
    >
      {isNewHeaderUVerify && <HeaderUverify />}
      <SidebarPro
        propsRoutes={routes}
        logo={logo}
        logoText={logoText}
        logoStratesys={logoStratesys}
        logoStratesysMini={logoStratesysMini}
      >
        <div
          ref={mainPanel}
          style={{
            width: "100%",
            height: "100%",
          }}
          className={mainPanelClasses}
        >
          <AdminNavbar {...rest} />

          <div className={classes.content}>
            <div className={classes.container}>
              <Outlet />
            </div>
          </div>

          <Footer fluid />
        </div>
      </SidebarPro>
    </div>
  );
}
